import { Fade, IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React from 'react'

import { getTranslate } from '../../localization'
import { Accommodation } from '../../types/accommodation'
import AccommodationRow from './AccommodationRow'
import AccommodationRowSkeleton from './AccommodationRow.skeleton'
import useStyles from './styles/AccommodationsTable.styles'

interface AccommodationListProps {
  data: Accommodation[]
  loading: boolean
  reloadData: () => void
  hasAccessToViewRoomType: boolean | undefined
  hasAccessToViewRatePlan: boolean | undefined
  RoleAccessToViewAccommodationDeatils: boolean | undefined
  RoleAccessToViewImportData: boolean | undefined
}

export const AccommodationsTable: React.FC<AccommodationListProps> = ({
  data,
  loading,
  reloadData,
  hasAccessToViewRoomType,
  hasAccessToViewRatePlan,
  RoleAccessToViewAccommodationDeatils,
  RoleAccessToViewImportData
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.tableHead}>
        <div>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <div>
          <Typography variant="body1">
            {getTranslate('Property Code')}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('NO. Rooms')}</Typography>
        </div>
        <div className={classes.refreshButtonContainer}>
          <IconButton
            data-cy="reloadDataForAccommodations"
            onClick={() => {
              reloadData()
            }}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
      {loading
        ? Array(5)
            .fill('')
            .map((item, index) => (
              <AccommodationRowSkeleton
                key={`accommodation-skeleton${item}${index.toString()}`}
              />
            ))
        : data.map((singleAccommodation: Accommodation) => (
            <Fade
              in
              timeout={600}
              key={singleAccommodation.basicDetails.propertyCode}>
              <div data-cy="tableRowAccomodationList">
                <AccommodationRow
                  hasAccessToViewRoomType={hasAccessToViewRoomType}
                  hasAccessToViewRatePlan={hasAccessToViewRatePlan}
                  data={singleAccommodation}
                  RoleAccessToViewAccommodationDeatils={
                    RoleAccessToViewAccommodationDeatils
                  }
                  RoleAccessToViewImportData={RoleAccessToViewImportData}
                />
              </div>
            </Fade>
          ))}
    </div>
  )
}
